import { IGenericType } from '@library/common/generictype';
import { QuotationSnapshot } from './quotation-snapshot';

export interface IKeys {
    fwq: string;
    serviceLevel: string;
    shipperNumber: string;
    consigneeNumber: string;
    billToNumber: string;
}

export const Keys = [ 'fwq', 'serviceLevel', 'shipperNumber', 'consigneeNumber', 'billToNumber'  ] as const;

export type Keys = typeof Keys[number];

export interface IKeyMap {
    label: string;
    display: string;
    field: ( s: QuotationSnapshot ) => IGenericType;
}

export type KeyMapObj<T> = {
    [ K in keyof T ]: IKeyMap;
}

export const KeysMap: KeyMapObj<IKeys> = {
    fwq: {
        label: 'Request',
        display: 'Request #',
        field: s => s.fwq,
    },
    serviceLevel: {
        label: 'Service Level',
        display: 'Service Level - ',
        field: s => s.serviceLevel,
    },
    shipperNumber: {
        label: 'Shipper Customer Number',
        display: 'Ship Ref - ',
        field: s =>
        ( s.references || [] ).filter( r => r && r.party === 'shipper' ).map( r => r['data'] || '' )[0] || '',
    },
    consigneeNumber: {
        label: 'Consignee Customer Number',
        display: 'Cons Ref - ',
        field: s =>
        ( s.references || [] ).filter( r => r && r.party === 'consignee' ).map( r => r['data'] || '' )[0] || '',
    },
    billToNumber: {
        label: 'Bill To Customer Number',
        display: 'Bill Ref - ',
        field: s => ( s.references || [] ).filter( r => r && r.party === 'bill_to' ).map( r => r['data'] || '' )[0] || '',
    },
}
